<template>
  <div>
    <div class="cas-ban">
      <img src="static/img/home_ban.png" />
    </div>
    <div class="cas-code">
      <img src="static/img/fail.png" v-if="isError" />
      <p>{{ response }}</p>
    </div>
  </div>
</template>
<script>
import { aApi } from "../utils/auth";
import Utils from "../utils/util";
import { Api } from '../utils/axios';
export default {
  data() {
    return {
      response: "认证登录中...",
      isError: false,
      baseUrl:""
    };
  },
  created() {
    if(!sessionStorage.getItem('schoolCode')||sessionStorage.getItem('schoolCode')==""||sessionStorage.getItem('schoolCode')==null){
       this.ss();
    }else{
      if(sessionStorage.getItem('schoolCode')=="12845"){
           document.title= "移动端";
      }else if(sessionStorage.getItem('schoolCode')=="14073"){
           document.title= "教务服务";
      }
    }
    if(sessionStorage.getItem('schoolCode')!="10011"){
        this.response = "当前功能未开放!";
        this.isError = true;
        return false
    }

    this.getAppkey()
  },
  methods: {
    getPwdKey(){
      let monthVal = new Date().getMonth();
      if(monthVal>=9){
        monthVal = monthVal+1;
      }else{
        monthVal = "0"+(monthVal+1);
      }
      let dateVal = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate();
      let keyArr = [];
      keyArr.push(new Date().getFullYear());
      keyArr.push(monthVal);
      keyArr.push(dateVal);
      let strpwd = "";
      let pwdPosion = "";
      for(let i=0;i<3;i++){
        let rndNb = Math.ceil(Math.random()*9);
        pwdPosion+=rndNb;
        for(let k=0;k<rndNb*1;k++){
          strpwd+=Math.ceil(Math.random()*9);
        }
        strpwd+=keyArr[i];
      }
      strpwd+=pwdPosion;
      return strpwd;
    },
    async ss() {
        let keystr = this.getPwdKey();
        const params = {
           'parmKeid':keystr
        }
        const res = await Api.getSchoolCode(params)
        sessionStorage.setItem('schoolCode',res.data.schoolcode);
        if(sessionStorage.getItem('schoolCode')=="12845"){
           document.title= "移动端";
        }else if(sessionStorage.getItem('schoolCode')=="14073"){
           document.title= "教务服务";
        }
    },
    async getAppkey(){
        let keystr = this.getPwdKey();
        let timestamp=Date.now();
        let parmKeid=Utils.encrypt(keystr+"@##@"+timestamp);
        const params = {
            'parmKeid':parmKeid
        }
        const res = await Api.getAppkey(params)
        if(res.code=="0"){
            this.isError = true;
            this.response = res.Msg;
            return false
        }
        this.baseUrl=res.baseUrl;

        this.addsdk(Utils.decrypt2(res.appkey))
    },
      async addsdk(appkey){
        var flag=true;
          try{
              if(typeof MCK == "undefined"){
                  var jsElem = document.createElement("script");

                  // 此处应该替换为mc-sdk.js的真实地址
                  jsElem.src = "static/mc-sdk.2.0.3.js";
                  document.body.appendChild(jsElem);
                  jsElem.onload = function(){
                      // 此处应该替换为你自己申请的
                      // 只能调用一次！！！！
                      MCK.auth(appkey);
                      // console.log("此时的appkey为:"+appkey)
                      // 可以多次调用（这是一个异步触发的回调函数）
                      MCK.ready(function(){
                          // 验证通过，可以放心调用 API
                          MCK.h5.call("getUserInfo", function (result) {
                              flag=false;
                              console.log(result)
                              if(result){
                                  this.getUser(result.userId)
                              }
                          });
                      });
                  };
              }
          }catch (e) {
              console.log(e)
          }
        if(flag){
            this.isError = true;
            this.response="认证不通过,登录失败!"
        }
      },
      getUser(useraccount){
          let timestamp=Date.now();
          let key=Utils.encrypt(useraccount+"@##@"+timestamp);
          key=key.replaceAll("+","%2B");
          // console.log(this.baseUrl+"/loginBjgsdx?key="+key+"&toMenu="+this.$route.query.toMenu)
          window.location.href=this.baseUrl+"/loginBjgsdx?key="+key+"&toMenu="+this.$route.query.toMenu;
      }
  }

};
</script>
<style lang="less" scoped>
.cas-ban {
  padding: 8px 20px;
  margin-top: 50px;
}
.cas-ban img {
  height: 111px;
  width: 100%;
}
.cas-code {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.cas-code img {
  width: 64px;
  height: 64px;
}
.cas-code p {
  color: @attendance-color-1;
  font-weight: 300;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/bjgsdxLogin.vue